const MAX_BACKOFF_MS = 30_000;
const BASE_BACKOFF_MS = 1_000;
const JITTER_MS = 250;

export function nextBackoffMs(attempt: number): number {
  const exponential = Math.min(MAX_BACKOFF_MS, BASE_BACKOFF_MS * 2 ** attempt);

  return exponential + Math.random() * JITTER_MS;
}

export function delayUntilAborted(ms: number, signal: AbortSignal): Promise<void> {
  return new Promise<void>((resolve) => {
    const finish = (): void => {
      clearTimeout(timer);
      signal.removeEventListener('abort', finish);
      resolve();
    };

    const timer = setTimeout(finish, ms);
    signal.addEventListener('abort', finish, { once: true });
  });
}
